import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IBeginBookingFlowInfo } from '@app/shared/services/booking/begin-booking-flow-info.model';

@Component({
  selector: 'app-booking-part',
  templateUrl: './booking-part.smart.component.html',
  styleUrls: ['./booking-part.smart.component.scss']
})
export class BookingPartSmartComponent {
  public bookingFlowInfo: IBeginBookingFlowInfo;
  public salonId: string;
  private router = inject(Router);

  constructor() {
    this.bookingFlowInfo = this.router.getCurrentNavigation().extras.state.dataForStartingBookingFlow;
  }
}
